import ReactGA from 'react-ga'

import envConfig from '../../../envConfig'
import { getCompanyName } from '../../../redux/account/selectors'
import { currentUser } from '../../../redux/auth/selectors'
import { store } from '../../../redux/store'

class EventsUtil {
  static setDimensions () {
    const state = store.getState()
    const { userId, email } = currentUser(state)
    const accountName = getCompanyName(state)

    ReactGA.set({
      dimension1: accountName,
      dimension2: userId,
      dimension3: email
    })
  }

  static sendEvent ({
    category = '',
    action = '',
    label = '',
    value,
    nonInteraction = false
  }) {
    EventsUtil.setDimensions()
    ReactGA.event({ category, action, label, value, nonInteraction })
  }
}

;(function initializeTracker ({ trackingId }) {
  ReactGA.initialize(trackingId, {
    debug: false
  })
}({ trackingId: envConfig.gaTrackingId }))

export default EventsUtil
